import React from 'react';

export const DashboardTicketsChartsGrid = ({
    dashboard,
    trendSeriesCreated,
    trendSeriesResolved,
    trendPointsCreated,
    trendPointsResolved,
    formatNumber,
}) => {
    const statusTotal = (dashboard?.tickets?.byStatus || []).reduce((accumulator, item) => accumulator + Number(item.total || 0), 0);
    const priorityTotal = (dashboard?.tickets?.byPriority || []).reduce((accumulator, item) => accumulator + Number(item.total || 0), 0);
    const typeTotal = (dashboard?.tickets?.byType || []).reduce((accumulator, item) => accumulator + Number(item.total || 0), 0);
    const sourceTotal = (dashboard?.tickets?.bySource || []).reduce((accumulator, item) => accumulator + Number(item.total || 0), 0);

    return (
        <div className="row g-3">
            <div className="col-12 col-xl-6">
                <div className="card card-body h-100">
                    <h6 className="mb-3">Tickets por estatus</h6>
                    {(dashboard?.tickets?.byStatus || []).map((item) => {
                        const percentage = statusTotal > 0 ? (Number(item.total || 0) / statusTotal) * 100 : 0;
                        return (
                            <div key={item.key} className="mb-2">
                                <div className="d-flex justify-content-between fs-12 mb-1">
                                    <span>{item.label || item.key}</span>
                                    <span>{formatNumber(item.total)}</span>
                                </div>
                                <div className="progress" style={{ height: '8px' }}>
                                    <div className="progress-bar bg-primary" style={{ width: `${percentage}%` }} />
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            <div className="col-12 col-xl-6">
                <div className="card card-body h-100">
                    <h6 className="mb-3">Tendencia creados vs resueltos</h6>
                    {(trendSeriesCreated.length > 0 || trendSeriesResolved.length > 0) ? (
                        <>
                            <svg viewBox="0 0 100 100" preserveAspectRatio="none" style={{ width: '100%', height: '180px' }}>
                                <polyline
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    className="text-primary"
                                    points={trendPointsCreated}
                                />
                                <polyline
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    className="text-success"
                                    points={trendPointsResolved}
                                />
                            </svg>
                            <div className="d-flex align-items-center gap-3 fs-11 text-muted mt-2">
                                <span className="d-inline-flex align-items-center gap-1"><i className="feather-minus text-primary" /> Creados</span>
                                <span className="d-inline-flex align-items-center gap-1"><i className="feather-minus text-success" /> Resueltos</span>
                            </div>
                            <div className="d-flex justify-content-between fs-11 text-muted mt-1">
                                <span>{trendSeriesCreated[0]?.date || trendSeriesResolved[0]?.date || '-'}</span>
                                <span>{trendSeriesCreated[trendSeriesCreated.length - 1]?.date || trendSeriesResolved[trendSeriesResolved.length - 1]?.date || '-'}</span>
                            </div>
                        </>
                    ) : (
                        <div className="text-muted fs-13">Sin datos para el rango seleccionado.</div>
                    )}
                </div>
            </div>

            <div className="col-12 col-xl-4">
                <div className="card card-body h-100">
                    <h6 className="mb-3">Tickets por prioridad</h6>
                    {(dashboard?.tickets?.byPriority || []).map((item) => {
                        const percentage = priorityTotal > 0 ? (Number(item.total || 0) / priorityTotal) * 100 : 0;
                        return (
                            <div key={item.key} className="mb-2">
                                <div className="d-flex justify-content-between fs-12 mb-1">
                                    <span>{item.label || item.key}</span>
                                    <span>{formatNumber(item.total)}</span>
                                </div>
                                <div className="progress" style={{ height: '8px' }}>
                                    <div className="progress-bar bg-warning" style={{ width: `${percentage}%` }} />
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            <div className="col-12 col-xl-4">
                <div className="card card-body h-100">
                    <h6 className="mb-3">Tickets por tipo</h6>
                    {(dashboard?.tickets?.byType || []).map((item) => {
                        const percentage = typeTotal > 0 ? (Number(item.total || 0) / typeTotal) * 100 : 0;
                        return (
                            <div key={item.key} className="mb-2">
                                <div className="d-flex justify-content-between fs-12 mb-1">
                                    <span>{item.label || item.key}</span>
                                    <span>{formatNumber(item.total)}</span>
                                </div>
                                <div className="progress" style={{ height: '8px' }}>
                                    <div className="progress-bar bg-info" style={{ width: `${percentage}%` }} />
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            <div className="col-12 col-xl-4">
                <div className="card card-body h-100">
                    <h6 className="mb-3">Tickets por origen</h6>
                    {(dashboard?.tickets?.bySource || []).map((item) => {
                        const percentage = sourceTotal > 0 ? (Number(item.total || 0) / sourceTotal) * 100 : 0;
                        return (
                            <div key={item.key} className="mb-2">
                                <div className="d-flex justify-content-between fs-12 mb-1">
                                    <span>{item.label || item.key}</span>
                                    <span>{formatNumber(item.total)}</span>
                                </div>
                                <div className="progress" style={{ height: '8px' }}>
                                    <div className="progress-bar bg-secondary" style={{ width: `${percentage}%` }} />
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            <div className="col-12 col-xl-6">
                <div className="card card-body h-100">
                    <h6 className="mb-3">Antigüedad de tickets abiertos</h6>
                    {(dashboard?.tickets?.openAging || []).map((item) => {
                        const total = Number(item.total || 0);
                        const max = Math.max(...(dashboard?.tickets?.openAging || []).map((row) => Number(row.total || 0)), 1);
                        const percentage = (total / max) * 100;
                        return (
                            <div key={item.key} className="mb-2">
                                <div className="d-flex justify-content-between fs-12 mb-1">
                                    <span>{item.label || item.key}</span>
                                    <span>{formatNumber(total)}</span>
                                </div>
                                <div className="progress" style={{ height: '8px' }}>
                                    <div className="progress-bar bg-danger" style={{ width: `${percentage}%` }} />
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            <div className="col-12 col-xl-6">
                <div className="card card-body h-100">
                    <h6 className="mb-3">Top responsables por tickets</h6>
                    <div className="table-responsive">
                        <table className="table table-sm align-middle mb-0">
                            <thead>
                                <tr>
                                    <th>Responsable</th>
                                    <th className="text-end">Tickets</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(dashboard?.tickets?.topAssignees || []).length === 0 && (
                                    <tr>
                                        <td colSpan={2} className="text-center text-muted py-3">Sin datos para mostrar.</td>
                                    </tr>
                                )}
                                {(dashboard?.tickets?.topAssignees || []).map((row) => (
                                    <tr key={row.userId || row.name}>
                                        <td>{row.name || '-'}</td>
                                        <td className="text-end fw-semibold">{formatNumber(row.total)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};
